import React, { Component } from "react";
import { Nav } from "react-bootstrap";

export default class Social extends Component {
  render() {
    return (
      <Nav className={this.props.type + " social"}>
        <Nav.Link
          href="https://www.facebook.com/RedlandsCommunityHospital/"
          target="_blank"
        >
          <i className="fa fa-facebook-f"></i>
        </Nav.Link>
        <Nav.Link href="https://twitter.com/RedlandsComHosp" target="_blank">
          <i className="fa fa-twitter"></i>
        </Nav.Link>
        <Nav.Link
          href="https://www.youtube.com/channel/UCBX9Mpdsd6S4qm_sAxb0jCg"
          target="_blank"
        >
          <i className="fa fa-youtube"></i>
        </Nav.Link>
        <Nav.Link
          href="https://www.instagram.com/redlands_community_hospital/"
          target="_blank"
        >
          <i className="fa fa-instagram"></i>
        </Nav.Link>
      </Nav>
    );
  }
}
